var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error){return (_vm.visible)?_c('p',{staticClass:"bg-gradient-danger w-100 text-white p-1 pl-2 text-center",domProps:{"innerHTML":_vm._s(error)}}):_vm._e()}),0)}
var staticRenderFns = []

export { render, staticRenderFns }